// Libs
import React from 'react';
import { ReactElement, useEffect } from 'react';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
// UI components
import { Typography, Skeleton } from 'ui-components';
// App
import { useAccountActivate } from 'app-shared/lib/api/user-access/account';

import Page from '@/layout/user-access/page';
import {
  UserAccessContentCard,
  UserAccessContentCardContainer,
} from 'app-shared/lib/components/cards/blurred-content-card';

import ActivateCallbackSuccess from './callback-success';
import ActivateCallbackError from './callback-error';
import Section from 'app-shared/lib/layout/shared/section';

import skeletonStyles from '@/styles/_skeleton.module.scss';
import styles from './page.module.scss';
import { AuthConfig } from '@/fragments/auth';

const ActivatePage = (): ReactElement => {
  const router = useRouter();
  const key: string = router.query.key as string;

  const { isLoading, error, execute: executeAccountActivate } = useAccountActivate(key);
  const isSuccess = isLoading == false && !error;
  const isError = isLoading == false && error;

  let message: ReactElement;

  /**
   * Call account activate api
   */
  useEffect(() => {
    if (key) {
      executeAccountActivate();
    }
  }, [key]);

  if (isSuccess) {
    message = <ActivateCallbackSuccess />;
  } else if (isError) {
    message = <ActivateCallbackError error={error} />;
  } else {
    message = (
      <Section>
        <Skeleton className={styles.skeletonText} variant="text" width={'50%'} />
        <Skeleton className={styles.skeletonText} variant="text" width={'66%'} />
        <Skeleton
          variant="rectangular"
          width={200}
          height={54}
          className={`${skeletonStyles.button} ${styles.skeletonButton}`}
        />
      </Section>
    );
  }

  return (
    <>
      <NextSeo noindex={true} />
      <Page showHeaderMainNav={false}>
        <UserAccessContentCardContainer>
          <UserAccessContentCard>
            <Typography variant="h1" align="center">
              Activation de votre compte
            </Typography>
            {message}
          </UserAccessContentCard>
        </UserAccessContentCardContainer>
      </Page>
    </>
  );
};

const authConfig: AuthConfig = {
  restrictedAccess: false,
};

ActivatePage.authConfig = authConfig;

export default ActivatePage;
